import axios, { AxiosError } from 'axios'
import { apiUrl } from './environment'
import { AuthError, LoginResponse, ErrorResponse } from '@/types/authTypes'

export const login = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const response = await axios.post(
      `${apiUrl}auth`,
      { email, password },
      {
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>
    const authError: AuthError = {
      message:
        axiosError.response?.data?.message || 'An error occurred during login',
      status: axiosError.response?.status || 500,
    }
    throw authError
  }
}

export const register = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const response = await axios.post(
      `${apiUrl}register`,
      { email, password },
      {
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>
    const authError: AuthError = {
      message:
        axiosError.response?.data?.message ||
        'An error occurred during registration',
      status: axiosError.response?.status || 500,
    }
    throw authError
  }
}
